import {Component, DoCheck, ElementRef, IterableDiffers, OnInit, ViewChild} from '@angular/core';
import {FileItem, FileUploader} from 'ng2-file-upload/ng2-file-upload';
import {User} from '../user';
import {MatSnackBar} from '@angular/material';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})

export class UploadComponent implements OnInit, DoCheck {

  @ViewChild('backInput') backInput: any;
  @ViewChild('frontInput') frontInput: any;

  front = 'front';
  back = 'back';
  element: ElementRef;
  called = false;
  moved = 0;
  user: User;
  clearBtn = 'Clear';
  private iterableDiffer;

  public uploader: FileUploader = new FileUploader({
    url: environment.upload.url,
    itemAlias: 'photo',
    allowedMimeType: ['image/png', 'image/jpeg', 'image/jpg']
  });

  constructor(element: ElementRef, private snackBar: MatSnackBar, private _iterableDiffers: IterableDiffers) {
    this.element = element;
    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
  }

  ngDoCheck() {
    const changes = this.iterableDiffer.diff(this.uploader.queue);
    if (changes) {
      switch (this.uploader.queue.length) {
        case 1:
          this.clearBtn = 'Clear Back';
          break;
        case 2:
          this.clearBtn = 'Clear Front';
          break;
        default:
          break;
      }
    }
  }

  ngOnInit() {
    // override the onAfterAddingfile property of the uploader so it doesn't authenticate with //credentials.
    // this.uploader.onAfterAddingFile = (file) => {
    //   file.withCredentials = false;
    // };
    this.user = JSON.parse(localStorage.getItem('user')) as User;
    this.uploader.setOptions({additionalParameter: {'id': this.user.user_id}});
    // this.uploader.onBuildItemForm = function(fileItem, form){
    //   form.append('user_id', localStorage.getItem('id'));
    //   return {
    //     fileItem, form
    //   }
    // };
    // this.uploader.uploadItem();

    this.uploader.onAfterAddingAll = (files: FileItem[]) => {
      files.forEach(fileItem => {
        if (!this.called) {
          this.called = true;
          fileItem.file.name = 'back';
        } else {
          this.called = false;
          fileItem.file.name = 'front';
        }
        fileItem.withCredentials = false;
      });
    };

    // override the onCompleteItem property of the uploader so we are able to deal with the server response.
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      const test = JSON.parse(response);
      if (test[0].moved) {
        this.moved++;
      }
    };

    this.uploader.onCompleteAll = () => {
      if (this.moved === 2) {
        this.uploadComplete();
        // notify the user
        this.snackBar.open('Thank you for your contribution!', 'OK', {
          duration: 3000
        });
      }
    };
  }

  selectInput = function (value) {
    this.element.nativeElement.querySelector('#' + value).click();
  };

  private clearForm = function () {
    switch (this.uploader.queue.length) {
      case 1:
        this.uploader.queue.pop();
        this.backInput.nativeElement.value = '';
        break;
      case 2:
        this.uploader.queue.pop();
        this.frontInput.nativeElement.value = '';
        break;
      default:
        break;
    }
  };

  private uploadComplete = function() {
    this.uploader.clearQueue();
    this.moved = 0;
    this.called = false;

    // also reset the input forms}
    this.backInput.nativeElement.value = '';
    this.frontInput.nativeElement.value = '';
  };
}
